import React from 'react';
import classNames from 'classnames';
const englishRules = new Intl.PluralRules('en', { type: 'ordinal' });
const suffixes = {
	one: 'st',
	two: 'nd',
	few: 'rd',
	other: 'th',
};
export const getSuffix = (number) => {
	return suffixes[englishRules.select(number)];
};

const NumberWithSuffix = ({ number: initialNumber, type }) => {
	let number = Number(initialNumber, 10);
	if (isNaN(number)) return <div className="suffix-num">{'-' || number}</div>;
	const suffix = getSuffix(number);
	const className = classNames({
		'suffix-num': true,
		[`--${type}`]: type,
		'--double-digit': number > 9,
		'--triple-digit': number > 90,
	});
	return (
		<div className={className}>
			<span className="suffix-num__content" data-suffix={suffix}>
				{number}
			</span>
		</div>
	);
};
export default NumberWithSuffix;
